import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Field } from 'redux-form'
import { renderTextField } from '../../Forms/fieldRenderers'

function CamposBusquedaCpa () {
  return (
    <Row style={{ marginBottom: '3%', padding: '22px' }} className='bg-white'>
      <Col md={4}>
        <Field
          name='numero'
          type='text'
          label='Número de CTG'
          component={renderTextField}
          autoFocus
          maxLength={12}
          minLength={9}
          placeholder='10200000000'
        />
      </Col>
      <Col md={4}>
        <Field
          name='camion'
          label='Patente camión'
          type='text'
          component={renderTextField}
          minLength={6}
          maxLength={7}
          placeholder='AA111BB ó AAA111'
        />
      </Col>
      <Col md={4}>
        <Field
          name='acoplado'
          type='text'
          label='Patente acoplado'
          component={renderTextField}
          autoFocus={false}
          minLength={6}
          maxLength={7}
          placeholder='AA111BB ó AAA111'
        />
      </Col>
    </Row>
  )
}

export default CamposBusquedaCpa
